<span class="hand" (click)="open()">
	{{ translate | translate }}
	<span class="identifier">{{ log.product.getAbbrev() }}-{{ log.task.number }}</span>
</span>
